import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationWebService } from '../authentication/authentication-web.service';
import { environment } from '../../../environments/environment';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class HttpService implements HttpInterceptor {
  constructor(
    private authService: AuthenticationWebService,
    private afAuth: AngularFireAuth
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = req.clone({ url: environment.cloudFunctionUrl + req.url });

    if (this.authService.isLoggedIn) {
      req = req.clone({
        url: req.url,
        setHeaders: {
          Authorization: 'Bearer ' + this.authService.userUid,
        },
      });
    } else {
      req = req.clone({
        url: req.url,
      });
    }

    return next.handle(req);
  }
}
